module.exports = __webpack_public_path__ + "static/img/weather_006.ed8e7a03.svg";